import Cookies from 'js-cookie';

const SESSION_TOKEN_KEY = 'invitationSessionToken';

function isLocalhost(): boolean {
  return typeof window !== 'undefined' && window.location.hostname === 'localhost';
}

function isHttps(): boolean {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

const Session = {
  /**
   * Obtiene el token almacenado en la cookie.
   */
  getToken: (): string | undefined => {
    const token = Cookies.get( SESSION_TOKEN_KEY );
    console.log( `[Session.getToken] Token retrieved: ${token}` );
    return token;
  },

  /**
   * Guarda un token en la cookie.
   *
   * @param token - El token a guardar.
   *
   * La cookie se configura con:
   * - `expires`: 1 día.
   * - `sameSite`: 'Strict' para evitar CSRF.
   * - `secure`: se marca como true solo si estamos en un entorno HTTPS y NO en localhost.
   *
   * Se realizan logs para depuración, informando si el entorno es seguro o no.
   */
  setToken: ( token: string ) => {
    if ( !token || typeof token !== 'string' ) {
      console.warn( '[Session.setToken] ⚠️ Token inválido recibido, no se guarda:', token );
      return;
    }

    // Solo marcar secure si está en HTTPS y
    //  NO en localhost (porque en localhost a menudo usamos HTTP)
    const secure = isHttps() && !isLocalhost();
    const options = {
      expires: 1, // 1 día
      sameSite: 'Strict' as const,
      secure,
    };

    if ( !secure ) {
      console.warn( '[Session.setToken] ⚠️ Entorno no seguro o en localhost. La cookie NO se marcará como secure.' );
    } else {
      console.info( '[Session.setToken] HTTPS detectado: la cookie se marcará como secure.' );
    }

    try {
      Cookies.set( SESSION_TOKEN_KEY, token, options );
      console.log( '[Session.setToken] ✅ Token guardado correctamente en la cookie con opciones:', options );
    } catch ( error ) {
      console.error( '[Session.setToken] ❌ Error al guardar la cookie:', error );
    }
  },

  /**
   * Elimina el token de la cookie.
   */
  clearToken: () => {
    Cookies.remove( SESSION_TOKEN_KEY );
    console.log( '[Session.clearToken] 🧹 Cookie eliminada.' );
  },
};

export default Session;
